import { render, staticRenderFns } from "./CollectionBar.vue?vue&type=template&id=e90b9f72"
import script from "./CollectionBar.vue?vue&type=script&lang=js"
export * from "./CollectionBar.vue?vue&type=script&lang=js"
import style0 from "./CollectionBar.vue?vue&type=style&index=0&id=e90b9f72&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports